import { FC } from 'react';
import { DeclarationBorderlessCardProps } from 'views/declarations/common/declaration.form.card';
import PlaceOfUseForm from './PlaceOfUseForm';

const FirstPlaceOfUseCard: FC<DeclarationBorderlessCardProps> = (props) => {
    return <PlaceOfUseForm propsPathPrefix="authorisation.firstPlaceOfUse" {...props} />;
};
export default FirstPlaceOfUseCard;
